<template>
  <div class="conmon-top" id="event-identity">
    <el-container>
      <el-main style="padding: 0" class="table-first-style">
        <el-row  class="search-title common-table-top" style="margin-top: 20px">
          <el-col :span="4" class="table-title">
            <i class="el-icon-document" style="font-weight: bold;"></i>
            <span>数据列表</span>
          </el-col>
          <el-col :span="20">
            <el-button type="primary" class="add-btn btn-right" style="margin-right: 0" @click="createDialog">创建</el-button>
          </el-col>
        </el-row>
        <el-table ref="multipleTable" :data="tableData" class="table" v-loading="loading">
          <el-table-column prop="name" label="事件名称" width=""></el-table-column>
          <el-table-column prop="stage_name" label="推进等级">
          </el-table-column>
          <el-table-column prop="score" label="评分标准"></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.is_system === 1" class="op-link" @click="openDialog(scope.row)">
                编辑
              </div>
              <div v-if="scope.row.is_system === 0" class="op-link" @click="createEdit(scope.row)">
                编辑
              </div>
              <div v-if="scope.row.is_system === 0" class="op-link" @click="deleteEvent(scope.row)">
                删除
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>

    <div class="table-foot">
      <el-pagination
        class="table-foot-pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>

    <!--默认事件编辑弹窗-->
    <el-dialog class="cellDialog base-dialog" title="客户事件" :visible.sync="adddialog" width="520px">
      <el-form ref="addForm" :model="addForm">
        <el-form-item label="事件名称:" :label-width="addLabelWidth">
          <el-input disabled class="stockInput" type="text" v-model="addForm.name" auto-complete="off" placeholder="输入事件名称"></el-input>
        </el-form-item>
        <el-form-item label="评分标准:" :label-width="addLabelWidth">
          <el-input class="stockInput" type="text" v-model="addForm.score" auto-complete="off" placeholder="输入评分标准"></el-input>
        </el-form-item>
        <el-form-item :label-width="addLabelWidth" label="推进等级" prop="percentage_id">
          <el-select v-model="addForm.stage_id" filterable placeholder="请选择推进等级" style="width:100%">
            <el-option
              v-for="item in stage"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="adddialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="confirmAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!--创建自定义事件弹窗-->
    <el-dialog class="cellDialog base-dialog custom-base-dialog"  title="客户事件" :visible.sync="createdialog" width="520px">
      <el-form ref="createForm" :model="createForm" :rules="rules">
        <el-form-item label="事件名称:" :label-width="addLabelWidth" prop="name">
          <el-input class="stockInput" type="text" v-model="createForm.name" auto-complete="off" placeholder="事件名称"></el-input>
        </el-form-item>
        <el-form-item label="事 件 ID :" :label-width="addLabelWidth" prop="identity" class="identity-input">
          <el-input  type="text" v-model="createForm.identity" auto-complete="off" placeholder="事件ID">
            <template slot="prepend">C_</template>
          </el-input>
        </el-form-item>
        <el-form-item :label-width="addLabelWidth" label="评分标准:" prop="score">
          <el-input class="" type="number" v-model="createForm.score" auto-complete="off" placeholder="评分分数"  onkeyup="this.value=this.value.replace(/[^\d]/g,'');"></el-input>
        </el-form-item>
        <el-form-item :label-width="addLabelWidth" label="推进等级:" prop="stage_id">
          <el-select v-model="createForm.stage_id" filterable placeholder="请选择推进等级" style="width:100%">
            <el-option
              v-for="item in stage"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="custom-attr">
        <p>事件附加属性:</p>
        <p style="font-size:12px;">在采集某些事件的时候，添加对事件的关键词描述</p>
        <div class="add-custom-attr">
          <el-button  type="primary" class="add-btn words-btn" @click="addTextAttr">文本属性</el-button>
          <el-button  type="primary" class="add-btn num-btn" @click="addNumberAttr">数量属性</el-button>
          <el-button  type="primary" class="add-btn money-btn" @click="addMoneyAttr">金额属性</el-button>
        </div>
        <div class="custom-attr-item" v-for="(item, index) in attrList" :key="index">
            <span v-if="item.attr_type === 'txt'">文本属性名称：<el-input v-model="item.attr_name" :disabled="item.disabled"></el-input></span>
            <span v-else-if="item.attr_type === 'number'">数量属性名称：<el-input v-model="item.attr_name" :disabled="item.disabled"></el-input></span>
            <span v-else-if="item.attr_type === 'money'">金额属性名称：<el-input v-model="item.attr_name" :disabled="item.disabled"></el-input></span>
            <span style="margin:0 10px 0 15px">属 性 ID：<el-input v-model="item.attr_identity" :disabled="item.disabled"></el-input></span>
            <i v-if="index>2" class="el-icon-close" style="line-height:36px;cursor:pointer" @click="deleteCustomAttr(index)"></i>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="createdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitForm('createForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--自定义事件编辑弹窗-->
    <el-dialog class="cellDialog base-dialog custom-base-dialog" title="客户事件" :visible.sync="editCustomdialog" width="520px">
      <el-form ref="createForm" :model="createForm" :rules="rules">
        <el-form-item label="事件名称:" :label-width="addLabelWidth" prop="name">
          <el-input class="stockInput" type="text" v-model="createForm.name" disabled auto-complete="off" placeholder="事件名称"></el-input>
        </el-form-item>
        <el-form-item label="事 件 ID :" :label-width="addLabelWidth" prop="name" class="identity-input">
          <el-input  type="text" v-model="createForm.identity" disabled auto-complete="off" placeholder="事件ID">
            <template slot="prepend">C_</template>
          </el-input>
        </el-form-item>
        <el-form-item :label-width="addLabelWidth" label="评分标准:" prop="name">
          <el-input class="stockInput" type="number" v-model="createForm.score" auto-complete="off" placeholder="评分分数"  onkeyup="this.value=this.value.replace(/[^\d]/g,'');"></el-input>
        </el-form-item>
        <el-form-item :label-width="addLabelWidth" label="推进等级:" prop="name">
          <el-select v-model="createForm.stage_id" filterable placeholder="请选择推进等级" style="width:100%">
            <el-option
              v-for="item in stage"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="custom-attr">
        <p>事件附加属性:</p>
        <p style="font-size:12px;margin-bottom:20px;">在采集某些事件的时候，添加对事件的关键词描述</p>
        <div class="add-custom-attr">
          <el-button  type="primary" class="add-btn words-btn" @click="addTextAttr">文本属性</el-button>
          <el-button  type="primary" class="add-btn num-btn" @click="addNumberAttr">数量属性</el-button>
          <el-button  type="primary" class="add-btn money-btn" @click="addMoneyAttr">金额属性</el-button>
        </div>
        <div class="custom-attr-item" v-for="(item, index) in attrList" :key="index">
          <span v-if="item.attr_type === 'txt'">文本属性名称：<el-input v-model="item.attr_name" :disabled="item.disabled"></el-input></span>
          <span v-else-if="item.attr_type === 'number'">数量属性名称：<el-input v-model="item.attr_name" :disabled="item.disabled"></el-input></span>
          <span v-else-if="item.attr_type === 'money'">金额属性名称：<el-input v-model="item.attr_name" :disabled="item.disabled"></el-input></span>
          <span style="margin:0 10px 0 15px">属 性 ID：<el-input v-model="item.attr_identity" :disabled="item.disabled"></el-input></span>
          <i v-if="index>2" class="el-icon-close" style="line-height:36px;cursor:pointer" @click="deleteCustomAttr(index)"></i>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="editCustomdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="confirmEditCreate(createForm)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCustomerEventList, getCustomerStage, editCustomerEvent, createCustomerEvent, deleteCustomerEvent, editNoSystemCustomerEvent } from '@/api/customer.js'
export default {
  name: 'customerEvent',
  data () {
    return {
      loading: true,
      tableData: [],
      attr_type: '',
      attrList: [
        {
          attr_name: '来源',
          attr_identity: 'source',
          attr_type: 'txt',
          disabled: true
        },
        {
          attr_name: '来源内容',
          attr_identity: 'source_content',
          attr_type: 'txt',
          disabled: true
        },
        {
          attr_name: '活动营销编码',
          attr_identity: 'serial_number',
          attr_type: 'txt',
          disabled: true
        }
      ],
      limit: 10,
      totalCount: 0,
      adddialog: false,
      createdialog: false,
      editCustomdialog: false,
      types: [],
      addForm: {
        name: '',
        score: '',
        stage_id: ''
      },
      createForm: {
        name: '',
        identity: '',
        score: '',
        stage_id: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入事件名称', trigger: 'blur' }
        ],
        identity: [
          { required: true, message: '请输入事件ID', trigger: 'blur' }
        ],
        score: [
          { required: true, message: '请输入评分标准', trigger: 'blur' }
        ],
        stage_id: [
          { required: true, message: '请输入推进等级', trigger: 'blur' }
        ]
      },
      stage: [],
      addLabelWidth: '80px',
      page: 1,
      editId: '',
      editNoSystemId: '',
      id: this.$route.query.id
    }
  },
  methods: {
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange(page) {
      this.page = page
      this.load()
    },
    // 获取客户等级
    getCustomerStages() {
      getCustomerStage().then((res) => {
        console.log(res)
        if (res.data.code === 0) {
          this.stage = res.data.data
        }
      })
    },
    // 获取客户事件列表
    load() {
      this.loading = true
      getCustomerEventList(this.page, this.limit).then((res) => {
        console.log(res)
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.total
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 系统事件编辑弹窗 确定
    confirmAdd() {
      editCustomerEvent(this.addForm, this.editId, this.attrList).then((res) => {
        if (res.data.code === 0) {
          this.adddialog = false
          this.load()
          _g.toastMsg('success', '编辑成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 非系统事件 自定义事件的编辑弹窗 确定按钮
    confirmEditCreate() {
      let form = JSON.parse(JSON.stringify(this.createForm))
      form.identity = 'C_' + form.identity
      for (let item of this.attrList) {
        if (item.attr_name === '') {
          _g.toastMsg('error', '属性名称不能为空')
          return
        }
        if (item.attr_identity === '') {
          _g.toastMsg('error', '属性ID不能为空')
          return
        }
      }
      editNoSystemCustomerEvent(form.name, form.identity, form.score, form.stage_id, this.attrList, this.editNoSystemId).then((res) => {
        if (res.data.code === 0) {
          this.editCustomdialog = false
          this.load()
          _g.toastMsg('success', '编辑成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmCreate()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 创建自定义弹窗确定按钮
    confirmCreate() {
      let form = JSON.parse(JSON.stringify(this.createForm))
      form.identity = 'C_' + form.identity
      for (let item of this.attrList) {
        if (item.attr_name === '') {
          _g.toastMsg('error', '属性名称不能为空')
          return
        }
        if (item.attr_identity === '') {
          _g.toastMsg('error', '属性ID不能为空')
          return
        }
      }
      createCustomerEvent(form.name, form.identity, form.score, form.stage_id, this.attrList).then((res) => {
        if (res.data.code === 0) {
          this.createdialog = false
          this.load()
          _g.toastMsg('success', '添加成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 打开编辑弹窗
    openDialog(item) {
      this.adddialog = true
      this.addForm.icon = item.icon
      this.addForm.name = item.name
      this.addForm.identity = item.identity
      this.addForm.stage_id = item.stage_id
      this.addForm.score = item.score
      this.editId = item.id
    },
    // 打开自定义事件编辑弹窗
    createEdit(item) {
      this.editCustomdialog = true
      this.createForm.name = item.name
      this.createForm.identity = item.identity.slice(2)
      this.createForm.stage_id = item.stage_id
      this.createForm.score = item.score
      this.editNoSystemId = item.id
      this.attrList = item.attr
    },
    // 添加自定义属性
    addTextAttr() {
      this.attrList.push(
        {
          attr_name: '',
          attr_identity: '',
          attr_type: 'txt',
          disabled: false
        }
      )
    },
    addNumberAttr() {
      this.attrList.push(
        {
          attr_name: '',
          attr_identity: '',
          attr_type: 'number',
          disabled: false
        }
      )
    },
    addMoneyAttr() {
      this.attrList.push(
        {
          attr_name: '',
          attr_identity: '',
          attr_type: 'money',
          disabled: false
        }
      )
    },
    // 删除自定义属性
    deleteCustomAttr(index) {
      this.attrList.splice(index, 1)
    },
    // 打开自定义事件创建弹窗
    createDialog() {
      this.createdialog = true
      this.createForm.name = ''
      this.createForm.identity = ''
      this.createForm.stage_id = ''
      this.createForm.score = ''
      this.attrList = [
        {
          attr_name: '来源',
          attr_identity: 'source',
          attr_type: 'txt',
          disabled: true
        },
        {
          attr_name: '来源内容',
          attr_identity: 'source_content',
          attr_type: 'txt',
          disabled: true
        },
        {
          attr_name: '活动营销编码',
          attr_identity: 'serial_number',
          attr_type: 'txt',
          disabled: true
        }
      ]
    },
    // 删除自定义事件
    deleteEvent(item) {
      this.$confirm('确认删除该客户事件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCustomerEvent(item.id).then((res) => {
          if (res.data.code === 0) {
            this.load()
            _g.toastMsg('success', '删除成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  created() {
    this.load()
    this.getCustomerStages()
  }
}
</script>

<style scoped>
  .table-title{
    text-align: left;
  }
  .custom-attr{
    width:450px;
    margin:28px auto 0;
  }
  .custom-attr p{
    margin:5px 15px;
    text-align: left;
  }
  .custom-attr-item{
    font-size: 14px;
    margin:10px 18px 10px 13px;
    position: relative;
    display: flex;
    justify-content: space-between;
  }
  .add-custom-attr{
    width:392px;
    margin:0 auto 18px;
    cursor: pointer;
    display:flex;
    justify-content: space-between;
  }
  .add-custom-attr .add-btn{
    padding:10px 31px;
    color:#fff;
    border-radius: 4px;
    margin:4px 0 0 0;
  }
  .el-icon-close{
    line-height: 36px;
    position:absolute;
    top:0;
    right:-10px;
  }
  .num-btn{
    background:#05b324;
    border-color:#05b324;
  }
  .words-btn{
    background:#1980ff;
    border-color:#1980ff;
  }
  .money-btn{
    background:#ff9f00;
    border-color:#ff9f00;
  }
</style>
